import { FC } from 'react';
import { TAnalyticArgs } from '@/containers/AnalyticsContainer';
import { useGetUserStatus } from '@/containers/UserStatusContainer';
import { Skeleton } from '@mofid-securities/uikit';
import { TextLink } from '@/components/Link';
import { useUnleash } from '@/unleash';

export const ProfileSubtitle: FC = () => {
  const { data, enabled, isReady } = useUnleash('web.general.menuSubtitle');
  const { status } = useGetUserStatus();

  const link = status === 'GUEST' ? data?.guestLink : data?.link;

  return (
    <span className="flex justify-center" onClick={(e) => e.stopPropagation()}>
      {!isReady ? (
        <Skeleton
          className="mx-auto md:max-lg:!h-9 md:max-lg:!w-[90px]"
          height={18}
          width={150}
        />
      ) : enabled ? (
        <TextLink
          analytics={[data?.analytic] as unknown as TAnalyticArgs}
          className="!block !text-xs md:!text-xxs"
          href={link || '/'}
          id={data?.analytic}
        >
          {data?.title + ' ' + data?.description}
        </TextLink>
      ) : (
        <span className="text-xxs !text-error">خطا در دریافت اطلاعات</span>
      )}
    </span>
  );
};
